import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yoga-courses',
  templateUrl: './yoga-courses.component.html',
  styleUrls: ['./yoga-courses.component.scss']
})
export class YogaCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
